const UserType = {
  INVESTOR: "investor",
  STARTUP: "startup",
  SCOUT: "scout",
  GUEST: "guest",
}

export default UserType;
